import { Link } from 'react-router-dom'

export function Register() {
  return (
    <div className="flex flex-1">
      <div className="flex-1 bg-register bg-cover bg-center">
        <div className="flex h-full w-full flex-1 flex-col items-center justify-center bg-black/60 duration-1000 hover:bg-black/0">
          <h1 className="card-title text-shadow-title text-center text-2xl text-white xl:text-4xl 2xl:text-6xl">
            Seja um guardião ambiental
          </h1>
          <div className="mt-16 flex flex-col gap-5 *:w-full *:text-nowrap lg:flex-row lg:gap-40">
            <Link
              to="/register/preserver"
              className="flex h-10 items-center justify-center rounded-lg border border-bios-secondary bg-bios-50 px-2 font-medium uppercase text-bios-secondary duration-300 hover:border-bios-primary hover:bg-bios-primary hover:text-white sm:px-10 sm:py-2 2xl:h-12"
              data-testid="register-preserver-link"
            >
              Quero ser um conservador
            </Link>
            <Link
              to="/register/sponsor"
              className="flex h-10 items-center justify-center rounded-lg border border-bios-secondary bg-bios-50 px-2 font-medium uppercase text-bios-secondary duration-300 hover:border-bios-primary hover:bg-bios-primary hover:text-white sm:px-10 sm:py-2 2xl:h-12"
              data-testid="register-sponsor-link"
            >
              Quero ser um patrocinador
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
